// Plugins Capacitor
import { Capacitor } from '@capacitor/core';
// import { NavigationBar } from '@hugotomazi/capacitor-navigation-bar';

const rgbToHex = (rgb: string): string => {
  // Convertit une chaîne RGB ("255 255 255") en hexadécimal ("#FFFFFF")
  const [r, g, b] = rgb.split(' ').map(Number);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
}

const isColorDark = (hexColor: string): boolean => {
  // 1) Retire le # si présent
  let hex = hexColor.replace('#', '');

  // 2) Parse les composantes R, G, B
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // 3) Calcule une luminance "simple" (Brightness)
  //    Formule : (0.299 * R) + (0.587 * G) + (0.114 * B)
  //    Le résultat est entre 0 et 255 environ.
  const brightness = (0.299 * r) + (0.587 * g) + (0.114 * b);

  // 4) Compare avec un seuil. 128 est souvent utilisé.
  //    brightness < 128 -> "sombre"
  //    brightness >= 128 -> "claire"
  return brightness < 128;
}

interface ThemeOptions {
	isDark?: boolean;
}
const Theme = async (props?: ThemeOptions) => {
	if(!Capacitor.isNativePlatform()) return;

	const computedStyles = getComputedStyle(document.documentElement);
	const beBackground = rgbToHex(computedStyles.getPropertyValue('--be-background').trim());

	// SI on ne définie pas props, on vient régler le theme de la status bar automatiquement
	if(!props) {
		props = {
			isDark: isColorDark(beBackground)
		};
	}
  
	// NavigationBar.setColor({
	// 	color: beBackground,
	// 	darkButtons: props.isDark ? false : true
	// });
}

interface InitializeOptions {
  theme?: ThemeOptions
}
const Initialize = async ({theme}: InitializeOptions = {}) => {
  if(!Capacitor.isNativePlatform()) return;
  
  await Theme(theme);
}

export const AppNavigationBar = {
	Initialize,
  Theme
}